var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSaveWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.923,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    d: "M4.239 7h21.299v17.538H4.239z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    d: "M23.222 6.396V3.761h-8.15L11.702 1H1v21.441h2.778"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#E5A033"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.111 15.377 3.282-3.3 3.281 3.433M15.425 20.385v-8.308"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSaveWhite);
export default __webpack_public_path__ + "static/media/ic_save_white.af0595a234ad40694f88ba6862cc2dfc.svg";
export { ForwardRef as ReactComponent };